import { render } from "./Footer.vue?vue&type=template&id=7052dcd0"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7052dcd0&lang=css"
script.render = render

export default script